/* eslint-disable */
import { useContext, useEffect } from 'react';
import { useParams } from 'react-router-dom';
import { BucketContext } from 'contexts/BucketContext';
import { SectionType } from 'sections/TabWrap';
import { FileInput } from 'components/FileInput';
import { Gallery } from './components/Gallery';
import * as S from './Images.styles';

const useImages = () => {
  const bucketContext = useContext(BucketContext);
  const { id } = useParams();
  const { listItems, urls, setUrls } = bucketContext;
  const path = `catalogue/users/${id}/`;

  const sendPhotos = (e: any) => {
    const files = [...e.target.files];

    bucketContext.sendItem(files, path).then(() =>
      bucketContext.getListItems(path).then((res: any) => {
        const resMapped = res?.map((item: any) => item.Key);
        bucketContext.viewItems(resMapped);
      })
    );
  };

  const deletePhoto = (key: string) => {
    if (key.split('-')[0] === 'inputItem') {
      const newPhotos = urls.filter((item: any) => item.id !== key);
      bucketContext.setUrls(newPhotos);
      return;
    }
    bucketContext.deleteItem(key).then(() =>
      bucketContext.getListItems(path).then((res: any) => {
        const resMapped = res?.map((item: any) => item.Key);
        bucketContext.viewItems(resMapped);
      })
    );
  };

  useEffect(() => {
    bucketContext.getListItems(`catalogue/users/${id}/`, true);
  }, [id]);

  useEffect(() => {
    if (listItems) {
      bucketContext.viewItems(listItems);
    } else {
      setUrls([]);
    }
  }, [listItems]);

  const sections: SectionType[] = [
    {
      id: 1,
      content: (
        <S.Container>
          {urls && urls.length > 0 ? <Gallery deletePhoto={deletePhoto} urls={urls} /> : null}

          <FileInput onChange={sendPhotos} />
        </S.Container>
      ),
    },
  ];

  return {
    sections,
  };
};

export { useImages };
